(function () {
  'use strict';

  function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var variants = JSON.parse(form.querySelector('[data-product-variants]').textContent);
      var idInput = form.querySelector('[name="id"]');
      var priceEl = form.querySelector('[data-product-price]');
      var submitBtn = form.querySelector('[data-add-to-cart]');
      var optionSelects = form.querySelectorAll('[data-option-select]');

      function currentSelection() {
        return Array.from(optionSelects).map(function (input) {
          if (input.type === 'radio') {
            var checked = form.querySelector('[data-option-select][name="' + input.name + '"]:checked');
            return checked ? checked.value : input.value;
          }
          return input.value;
        });
      }

      function findVariant(selection) {
        return variants.find(function (variant) {
          return variant.options.every(function (opt, i) {
            return opt === selection[i];
          });
        });
      }

      function update() {
        var variant = findVariant(currentSelection());
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price_formatted;
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available
            ? submitBtn.getAttribute('data-label-available')
            : submitBtn.getAttribute('data-label-sold-out');
        }

        var selectedLabels = form.querySelectorAll('.size-pill');
        selectedLabels.forEach(function (label) {
          var input = label.querySelector('[data-option-select]');
          if (!input) return;
          label.classList.toggle('size-pill--selected', input.checked);
        });
      }

      optionSelects.forEach(function (input) {
        input.addEventListener('change', update);
      });

      var qtyInput = form.querySelector('.qty-stepper__input');
      var decreaseBtn = form.querySelector('[data-qty-decrease]');
      var increaseBtn = form.querySelector('[data-qty-increase]');

      if (qtyInput && decreaseBtn && increaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          var value = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = Math.max(1, value - 1);
        });
        increaseBtn.addEventListener('click', function () {
          var value = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = value + 1;
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initProductForms);
})();
